import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import HowItWorks from '../components/home/HowItWorks';

export default function HowItWorksPage() {
  const { t } = useLanguage();

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>{t.nav.howItWorks}</h1>
          <p>{t.steps.subtitle}</p>
        </div>
      </div>
      <HowItWorks showHeader={false} showCta />
    </>
  );
}
